<template>
  <main class="dashboard">
    <div class="d-flex pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">Мониторинг отзывов: Настройки</h1>
      <router-link active-class="active" class="btn btn-sm ms-auto" title="Назад"
                   :to="{name: 'reviews_monitor'}">
        <b class="h3"><i class="bi bi-x-lg"></i></b>
      </router-link>
    </div>

    <div class="card text-center">
      <div class="card-header">
        <ul class="nav nav-tabs card-header-tabs">
          <li class="nav-item" v-for="(page, key) in pages">
            <a :class="'nav-link text-dark ' + (current===key?' active':'')" @click.prevent="current=key"
               aria-current="true" href="#">{{ page }}</a>
          </li>
        </ul>
      </div>

      <div class="card-body text-start">
        <form class="d-flex" v-if="current === 'date'" style="gap: 10px" @submit.prevent="saveSettings">
          <div v-if="settings">
            <div>
              <label class="form-label">По количеству отзывов</label>
              <input type="number" v-model="settings.review_count" class="form-control">
            </div>

            <div>
              <label class="form-label">По датам</label>
              <date-picker v-model="settings.review_date_start" style="width: 250px"
                           locale="ru"
                           :clearable="false"
                           format="dd.MM.yyyy"
                           model-type="yyyy-MM-dd"
                           auto-apply
                           :enable-time-picker="false"></date-picker>
            </div>


            <div class="mt-2">
              <label for="name" class="form-label mt-3">График запуска парсера</label>
              <MultiSelect v-if="weekdays.length"
                           v-model="settings.restart_weekday"
                           :options="weekdays"
                           :only_value="true"
                           :multi="true"
              >
              </MultiSelect>
            </div>
            <div class="mt-2">
              <label for="name" class="form-label mt-3">Время запуска парсера</label>

               <date-picker v-model="settings.restart_time" style="width: 250px"
                           locale="ru"
                           :clearable="false"
                           format="HH:mm:ss"
                           model-type="HH:mm:ss"
                           auto-apply
                            time-picker
                           :enable-time-picker="true"></date-picker>
            </div>
            <div class="mt-2">
              <label for="name" class="form-label mt-3">Количество дней парсинга</label>
              <input type="number" class="form-control" v-model="settings.restart_day_back">

              <div class="help-text">
                Дни назад для парсинга
              </div>
            </div>
          </div>

          <button type="submit" class="btn btn-success">Сохранить</button>
        </form>
        <template v-else>
          <template v-for="category in tags">
            <div class="card-header bg-secondary">
              {{ category.name }}
            </div>
            <ul class="list-group list-group-flush">
              <li v-for="tag in category.tags" class="list-group-item">
                <span class="badge text-bg-secondary">{{ tag.name }}</span> - <i>{{ tag.comment }}</i>
              </li>
            </ul>
          </template>

        </template>


      </div>
    </div>


  </main>
</template>

<script>
import dataMixin from '../mixins.js';
import {DictionaryApi} from '@/api/dictionary'
import moment from "moment";

export default {
  name: 'ReviewSettings',
  data() {
    return {
      name: 'reviews_monitor',
      current: "date",
      pages: {date: "Настройка глубины парсинга", tag: "Теги"},
      settings: null,
      tags: []
    }
  },
  computed: {
    weekdays() {
      return Array.apply(null, Array(7)).map(function (_, i) {
        return {'name': moment(i, 'e').startOf('week').isoWeekday(i + 1).format('dddd'), 'id': i};
      })
    }
  },
  watch: {},
  mounted() {
    DictionaryApi.get_list('reviews_tags', 1, 200).then(response => this.tags = response.results)
    DictionaryApi.get_review_settings(this.name).then(response => this.settings = response)
  },
  methods: {
    saveSettings() {
      const $this = this;
      DictionaryApi.save_review_settings(this.name, this.settings).then(() => {
        $this.$notify({
          type: "success",
          text: 'Настройки сохранены'
        })
      })
    }
  }
}
</script>
<style scoped lang="scss">
form {
  display: flex;
  gap: 10px;
  align-items: center;

  button {
    margin-top: auto;
  }
}

</style>


